import manager from "../Manager";

function TextPreview({ data, index, inEditor, structures }) {
    return (
        <div className="tbcourse-template tbcourse-template-text" key={index}>
            <div>
                <div className="tbcourse-template-text-title">{data?.title ? data.title : structures.title?.placeholder}</div>
                <div className="tbcourse-template-text-description" dangerouslySetInnerHTML={{ __html: data?.description ? data.description : manager.inEditor ? structures.description.placeholder : '' }}></div>
            </div>
        </div>
    )
}

export default TextPreview;
